function MapGoogle(){
    return (
<div className="w-full   overflow-hidden rounded-xl shadow ">
  <div className="relative w-full aspect-[16/9] px-2 ">
         <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2314.370441593597!2d18.308079977045775!3d54.544594984397115!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x81f804406df613cd%3A0x1f92490bef2b80c3!2sDrzewus%20-%20Us%C5%82ugi%20ogrodnicze%20i%20prace%20ziemne!5e0!3m2!1spl!2spl!4v1772456964645!5m2!1spl!2spl"
          className="w-full h-full border-0"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
            title="Mapa Drzewus"
            >
          </iframe>   
        </div>
          </div>
     

    )
}

export default MapGoogle